import { useEffect, useState } from 'react';

type ScrollDirection = 'UP' | 'DOWN';

type UseElementScrollProps = {
  direction?: ScrollDirection;
};

function useElementScroll({ direction = 'DOWN' }: UseElementScrollProps) {
  const [scrollPosition, setScrollPosition] = useState<number>(0);
  const [scrollDirection, setScrollDirection] = useState<ScrollDirection>(direction);

  const handleScroll = (scrollPosition: number): void => {
    const direction = window.scrollY > scrollPosition ? 'DOWN' : 'UP';
    setScrollDirection(direction);
    setScrollPosition(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', () => handleScroll(scrollPosition));
    return () => window.removeEventListener('scroll', () => handleScroll(scrollPosition));
  }, [scrollPosition]);

  return { scrollPosition, scrollDirection };
}

export { useElementScroll };
